import PropTypes from "prop-types";

import { useState, useEffect } from "react";
import axios from "axios";
import Loading from "./Loading";

export default function Screen2({ onNext, country_iso2_code, brand_id }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      console.log("country_iso2_code", country_iso2_code);
      try {
        if (!country_iso2_code) {
          setError("Missing country_iso2_code");
          console.error("Missing country_iso2_code", {
            country_iso2_code,
          });

          throw new Error("Missing country_iso2_code");
          setLoading(false);
        }

        if (!brand_id) {
          setError("Missing brand_id");
          console.error("Missing brand_id", {
            brand_id,
          });

          throw new Error("Missing brand_id");
          setLoading(false);
        }

        const response = await axios.get(
          `https://epremise-api.b-fonline.com/products/${country_iso2_code}/${brand_id}`
        );
        setProducts(Object.values(response.data)); // Convert response to array if needed
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
        console.error("Error fetching products", err);
      }
    };

    fetchData();
  }, [country_iso2_code, brand_id]);

  const handleProductSelect = (product) => {
    onNext(product); // Pass the entire product object to the parent component
  };

  if (loading) return <Loading />;
  if (error)
    return (
      <div id="bf-chat-window-screen-2" className="screen error">
        <div className="wrapper">
          <div className="row">
            <div className="col">
              <h2 className="title">Missing from the cellar</h2>
              <p>
                The bottle you're looking for isn't where it should be. While we
                track it down, explore our other spirits. We'll have it back on
                the shelf soon!
              </p>
            </div>
          </div>
        </div>
      </div>
    );

  return (
    <>
      <div id="bf-chat-window-screen-2" className="screen">
        <div className="wrapper">
          <div className="row">
            <div className="col">
              <h2 className="title">Select your product</h2>
              <ul className="select-product">
                {products.map((product, index) => (
                  <li key={index}>
                    <button
                      onClick={() => handleProductSelect(product)}
                      className="btn"
                    >
                      {product.product_name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

Screen2.propTypes = {
  onNext: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  country_iso2_code: PropTypes.string.isRequired,
  brand_id: PropTypes.string.isRequired, // Expected type for brand_id
};
